let cachedDate: Date | null = null;

/**
 * Returns the current date, cached to avoid re-reading the system clock. This is useful for preventing unnecessary
 * re-fetch of queries that depend on the current date. cachedDate is frozen to prevent mutation.
 */
export const getCachedDateOfNow = () => {
  cachedDate ??= Object.freeze(new Date());
  return new Date(cachedDate);
};
